module.exports = __webpack_public_path__ + "img/76_13.0c949747.png";